import React from 'react';

import { Tooltip } from '@bringg/react-components';
import { PickupDropoffOption } from '@bringg/types';

import type { RoutesPlannerTranslations } from '../../../../routes-planner/translations';

interface Props {
	pickupDropOffOption: PickupDropoffOption;
	translations: RoutesPlannerTranslations;
}

const PickupDropoffColumn = ({ pickupDropOffOption, translations }: Props) => {
	const getColumnHtml = () => {
		if (pickupDropOffOption === PickupDropoffOption.PICKUP) {
			return (
				<div className="pickup" data-test-id="order-type">
					{translations.routesTableTranslations.groupHeaders.pickup}
				</div>
			);
		}
		if (pickupDropOffOption === PickupDropoffOption.DROPOFF) {
			return (
				<div className="dropoff" data-test-id="order-type">
					{translations.routesTableTranslations.groupHeaders.dropoff}
				</div>
			);
		}
		return (
			<div data-test-id="order-type">
				<span className="pickup">{translations.routesTableTranslations.groupHeaders.pickup}</span>
				<span className="dropoff">{translations.routesTableTranslations.groupHeaders.dropoff}</span>
			</div>
		);
	};
	const getTooltipKey = () => {
		if (pickupDropOffOption === PickupDropoffOption.PICKUP) {
			return 'pickupTooltip';
		}
		if (pickupDropOffOption === PickupDropoffOption.DROPOFF) {
			return 'dropoffTooltip';
		}
		return 'bothTooltip';
	};
	return (
		<Tooltip title={translations.routesTableTranslations.groupHeaders[getTooltipKey()]}>{getColumnHtml()}</Tooltip>
	);
};

export default PickupDropoffColumn;
